import { useBranchRole } from "@/hooks/use-branch-role";
import { useSubscriptionStatus } from "@/hooks/use-subscription-status";
import { type CollectionActions, hasPermission } from "@/lib/permissions";

type UseHasPermissionProps<T extends keyof CollectionActions> = {
	collection: T;
	action: keyof CollectionActions[T];
};

export function useHasPermission<T extends keyof CollectionActions>({ collection, action }: UseHasPermissionProps<T>) {
	const role = useBranchRole();
	const { canPerformActions, showBlockedModal, isLoading } = useSubscriptionStatus();

	const has = role && hasPermission({ role, collection, action });
	const allowed = has && canPerformActions;
	const blockedBySubscription = has && !canPerformActions;
	const blockedByRole = !has && !!role;

	return {
		allowed,
		/** Role alone would allow it, but subscription blocks it */
		blockedBySubscription,
		/** Subscription is fine, but the role doesn't allow it */
		blockedByRole,
		isLoading,
		showBlockedModal,
	};
}
